const firebaseApiKey = 'AIzaSyCvYtk0l6XcXLfr7xVhAtN-W8yw0PLTNaA';
const googleMapsApiKey = 'AIzaSyCvYtk0l6XcXLfr7xVhAtN-W8yw0PLTNaA';

export { firebaseApiKey, googleMapsApiKey };
